export const GET_ALL_PLAYERS = "GET_ALL_PLAYERS";
export const ADD_PLAYER = "ADD_PLAYER";
export const EDIT_PLAYER = "EDIT_PLAYER";
export const DELETE_PLAYER = "DELETE_PLAYER";

export const GET_PLAYER_STATUSES = "GET_PLAYER_STATUSES";
export const GET_PLAYER_POSITIONS = "GET_PLAYER_POSITIONS";